import React from "react";
import { BaseLayout } from "@components/components";

export const AuthorizationBase = () => {
    return <BaseLayout full />;
};
